import { render } from "./UserTicketView.vue?vue&type=template&id=384ec722&scoped=true"
import script from "./UserTicketView.vue?vue&type=script&lang=js"
export * from "./UserTicketView.vue?vue&type=script&lang=js"

import "./UserTicketView.vue?vue&type=style&index=0&id=384ec722&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-384ec722"]])

export default __exports__